import userManager from "@/core/userManager";
import {
  STORAGE_TYPE
} from "@/core/userManager";

const storageType = STORAGE_TYPE.SESSION;

const default_cacheData = {
  token: null,
  queryType: null,
  searchCondition: null
};

const signInQuery = {
  namespaced: true,
  state: {
    cacheData: null
  },
  getters: {
    storeCacheData: (state) => {
      let storeValue = userManager.getAttrValue("signInQuery_cacheData", storageType);
      let jsonValue = JSON.stringify(state.cacheData);
      if (!!storeValue && jsonValue != storeValue) {
        try {
          storeValue = JSON.parse(storeValue);
          if (storeValue.token == userManager.token)
            state.cacheData = storeValue;
        } catch (error) {
          console.error(error);
        }
      }

      return state.cacheData;
    },
    storeQueryType: (state, getters) => {
      let cacheData = getters.storeCacheData;
      if (!cacheData || !cacheData.queryType) return null;

      return cacheData.queryType;
    },
    storeSearchCondition: (state, getters) => {
      let cacheData = getters.storeCacheData;
      if (!cacheData || !cacheData.searchCondition) return null;

      return Object.clone(cacheData.searchCondition);
    }
  },
  mutations: {
    updateQueryType(state, newValue) {
      let cacheData = this.getters["signInQuery/storeCacheData"] || Object.clone(default_cacheData);
      if (cacheData.queryType == newValue) return;

      if (!cacheData.token) {
        cacheData.token = userManager.token;
        state.cacheData = cacheData;
      }
      state.cacheData.queryType = newValue;
      state.cacheData.searchCondition = null;
      userManager.setAttrValue("signInQuery_cacheData", state.cacheData, storageType);
    },
    updateSearchCondition(state, newValue) {
      let cacheData = this.getters["signInQuery/storeCacheData"] || Object.clone(default_cacheData);
      if (Object.valueEquals(cacheData.searchCondition, newValue)) return;

      if (!cacheData.token) {
        cacheData.token = userManager.token;
        state.cacheData = cacheData;
      }
      state.cacheData.searchCondition = Object.clone(newValue);
      userManager.setAttrValue("signInQuery_cacheData", state.cacheData, storageType);
    },
    updateSignInQueryAll(state, newValue) {
      if (!!newValue) {
        this.commit("signInQuery/updateQueryType", newValue.queryType);
        this.commit("signInQuery/updateSearchCondition", newValue.searchCondition);
      }
    }
  },
  actions: {
    updateQueryTypeAsync({
      commit
    }, newValue) {
      commit("updateQueryType", newValue);
    },
    updateSearchConditionAsync({
      commit
    }, newValue) {
      commit("updateSearchCondition", newValue);
    },
    updateSignInQueryAllAsync({
      commit
    }, newValue) {
      commit("updateSignInQueryAll", newValue);
    }
  }
};

export default signInQuery;



// WEBPACK FOOTER //
// ./src/store/modules/signInQuery.js